import { BasePlugin } from '../base'
import mdcElevation from './mdc-elevation.vue'

export { mdcElevation }

export default BasePlugin({
  mdcElevation
})
